import React, { useState } from 'react';
import { Grid, Container } from '@material-ui/core';
import ApoutImg from '../../../assets/images/homeAbout.png';
import { lang } from '../../../config/app.config';
// import { fetchIntroduction } from '../../../services/about.service';
import Preloader from '../../../components/PreLoader';
import { useSelector } from 'react-redux';
import { TranslationState } from '../../../store/ActionReducers/translation.actionreducer';

const HomeAbout: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  // const [introduction, setIntroduction] = useState<string>('');
  const stateTr = useSelector((state: { translation: TranslationState }) => state.translation);


  // const getIntroduction = async () => {
  //   setLoading(true);
  //   const about = await fetchIntroduction();
  //   setIntroduction(about);
  //   setLoading(false);
  // }

  // useEffect(() => {
  //   getIntroduction();
  // }, [])

  return (
    <>
      {loading ? <Preloader /> :
        <div className='section-break-2 home-about'>
          <Container maxWidth="lg">
            <Grid container spacing={2}>
              <Grid item md={6} lg={4} xl={4}>
                <img src={ApoutImg} alt="" className="img-fluid" />
              </Grid>

              <Grid item md={6} lg={8} xl={8}>
                <div className="home-about--info">
                  <h3 className="text-22">{lang === 'en' ? 'Introduction' : 'परिचय'}</h3>
                  <p className='text-14-primary text-justify'>
                    {stateTr?.translation?.introduction_text[lang === 'np' ? "value_np" : "value_en"]}</p>
                </div>
              </Grid>
            </Grid>
          </Container>
        </div>
      }
    </>
  );
}

export default HomeAbout;